export default [
  {
    path: '/anti-coi',
    name: 'anti-coi',
    component: () => import('@/view/anti-coi/index.vue'),
  },
];
